import React from 'react'
import { extractMetaErrorLinks } from '../../libs/metaErrors'

// O endereço fica visível para o operador conferir o destino antes de abrir.
// Não altera nem interpreta o HTML do detalhe técnico preservado no expansor.
export default function MetaErrorLinks({ tecnico }) {
  const links = extractMetaErrorLinks(tecnico)
  if (!links.length) return null

  return (
    <span className="block mt-1 text-xs break-words">
      <span className="font-semibold">Links informados no detalhe:</span>
      {links.map((url) => (
        <a
          key={url}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="block underline"
          onClick={(event) => event.stopPropagation()}
        >
          {url}
        </a>
      ))}
    </span>
  )
}
